import Divider from 'components/_UI/Divider';
import Text from 'components/_UI/Text';
import React, { useEffect } from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import colors from 'theme/colors';
import CardTickets from './card/CardTickets';
import breakpoints from 'theme/breakpoints';
import { Row } from 'styled/alignment/Row';
import Organizers from '../organizers/Organizers';
import { StyledDivider } from 'styled/UI/StyledDivider';
import Participants from '../participants/Participants';
import { useEventDetailTab } from 'context/dash/EventDetailTab';
import Icon from 'components/_UI/Icon';





function fmtCurrency(value) {
    return Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function TicketsForSale({ data, detailEvent, offlineStats }) {
    let setEventDetailTab;
    if (!detailEvent) {
        ({ setEventDetailTab } = useEventDetailTab());
    }

    return (
        <ContainerTickets>
            {/* <Divider marginTop={'40px'} color={colors.primaryDashboard} opacity={0.3} /> */}

            <StyledContent>
                <Row>
                    <Column width='20px' height='20px' >
                        <Icon name='tickets' color={colors.secondaryPurple} size='20px' />
                    </Column>
                    <StyledText>
                        <Text name='subtitle' color={colors.nightDark}>Ingressos a venda</Text>
                    </StyledText>
                </Row>

                <MainContent>
                    <ContentTickets>
                        {
                            data?.filter((el) => el.type === 'ticket').map((el) => (
                                <Column marginTop='15px' key={el.id}>
                                    <CardTickets data={el} onTicketClick={() => setEventDetailTab('tickets')} />
                                </Column>
                            ))

                        }
                    </ContentTickets>

                    {offlineStats && (
                        <OfflineSection>
                            <OfflineDivider>Vendas no PDV</OfflineDivider>
                            <OfflineCards>
                                <OfflineCard>
                                    <OfflineCardLabel>Ingressos vendidos</OfflineCardLabel>
                                    <OfflineCardValue>{offlineStats.sold}</OfflineCardValue>
                                </OfflineCard>
                                <OfflineCard>
                                    <OfflineCardLabel>Receita</OfflineCardLabel>
                                    <OfflineCardValue>{fmtCurrency(offlineStats.revenue)}</OfflineCardValue>
                                </OfflineCard>
                            </OfflineCards>
                            <OfflineHint>Vendas realizadas pelo caixa presencial vinculado a este evento</OfflineHint>
                        </OfflineSection>
                    )}


                    {!detailEvent &&
                        <>
                            <DividerStyled marginBottom={'20px'} color={colors.primaryDashboard} opacity={0.3} />
                            <StyledPeoples>
                                <Organizers />
                            </StyledPeoples>
                        </>
                    }

                    {/* <Participants data={participants} /> */}

                </MainContent>
            </StyledContent>

        </ContainerTickets>
    )
}

const ContainerTickets = styled(Column)`
    width: 100%;
`;

const StyledContent = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    
    @media screen and (min-width: 690px) {
        display: flex;
        flex-direction: column;
    }
`;

const MainContent = styled.div`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: 690px) {
        flex-direction: row;
    }

`;

const ContentTickets = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-bottom: 20px;
    @media screen and (min-width: 690px) {
        width: 50%;
        padding: 10px 20px 0px 10px;
        border-right: 1px solid #cccc;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
    }
`;


const StyledText = styled(Row)`
    padding: 0;
    height: 20px;
    @media screen and (min-width: 690px){
        padding: 0 10px 0 10px;
    }
`;

const StyledPeoples = styled.div`
    width: 50%;

    @media screen and (min-width: 690px) {
        border-left: 1px solid #cccc;
    }
`

const DividerStyled = styled(StyledDivider)`
    display: flex;
    @media screen and (min-width: 690px) {
        display: none;
    }
`;

const OfflineSection = styled.div`
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    width: 100%;
`;

const OfflineDivider = styled.p`
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${colors.nightLight};
    margin: 0 0 12px;
`;

const OfflineCards = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
`;

const OfflineCard = styled.div`
    background: #f5f5f7;
    border-radius: 10px;
    padding: 12px 16px;
    min-width: 120px;
`;

const OfflineCardLabel = styled.p`
    font-size: 12px;
    color: ${colors.nightLight};
    margin: 0 0 4px;
`;

const OfflineCardValue = styled.p`
    font-size: 18px;
    font-weight: 700;
    color: ${colors.nightDark};
    margin: 0;
`;

const OfflineHint = styled.p`
    font-size: 12px;
    color: ${colors.nightLight};
    margin: 10px 0 0;
    font-style: italic;
`;
